import { render } from "./canned.vue?vue&type=template&id=831d1bec"
import script from "./canned.vue?vue&type=script&lang=js"
export * from "./canned.vue?vue&type=script&lang=js"

import "./canned.vue?vue&type=style&index=0&id=831d1bec&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__